import React from 'react'
import { FaCogs, FaPaperclip } from 'react-icons/fa'
import { Link } from 'react-router-dom'

export default () => {
    return (
        <>
            <div className="adminLink">
                <Link to={`/admin/reports`}>
                    <button className="button is-info is-small">
                        <span className="icon is-small">
                            <FaPaperclip />
                        </span>
                        <span>Reporting Menu</span>
                    </button>
                </Link>
            </div>
            <div className="adminLink">
                <Link to={`/admin/dashboard`}>
                    <button className="button is-info is-small">
                        <span className="icon is-small">
                            <FaCogs />
                        </span>
                        <span>Dashboard Admin</span>
                    </button>
                </Link>
            </div>
        </>
    )
}
